import {
  ENGLISH_LOCALE_IDENTIFIER,
  GERMAN_LOCALE_IDENTIFIER,
} from 'constants/i18n';
import recomentationToolDE from 'public/static/home/cta-section/rectool-de.png';
import recomentationToolEN from 'public/static/home/cta-section/rectool-en.png';
import differentiationSecondImage from 'public/static/home/differentiation-section/advice.png';
import differentiationThirdImage from 'public/static/home/differentiation-section/app.png';
import differentiationFirstImage from 'public/static/home/differentiation-section/lifestyle.png';
import heroImageDE from 'public/static/home/hero-section/image-de.png';
import heroImageEN from 'public/static/home/hero-section/image-en.png';
import uspImage from 'public/static/home/usp-section/usp.png';

const images = {
  hero: {
    [ENGLISH_LOCALE_IDENTIFIER]: heroImageEN,
    [GERMAN_LOCALE_IDENTIFIER]: heroImageDE,
  },
  uniqueSellingPoints: {
    [ENGLISH_LOCALE_IDENTIFIER]: uspImage,
    [GERMAN_LOCALE_IDENTIFIER]: uspImage,
  },
  recTool: {
    [ENGLISH_LOCALE_IDENTIFIER]: recomentationToolEN,
    [GERMAN_LOCALE_IDENTIFIER]: recomentationToolDE,
  },
  differentiation1: {
    [ENGLISH_LOCALE_IDENTIFIER]: differentiationFirstImage,
    [GERMAN_LOCALE_IDENTIFIER]: differentiationFirstImage,
  },
  differentiation2: {
    [ENGLISH_LOCALE_IDENTIFIER]: differentiationSecondImage,
    [GERMAN_LOCALE_IDENTIFIER]: differentiationSecondImage,
  },
  differentiation3: {
    [ENGLISH_LOCALE_IDENTIFIER]: differentiationThirdImage,
    [GERMAN_LOCALE_IDENTIFIER]: differentiationThirdImage,
  },
};

export default images;
